export const TableSortAsc = 'ASC';
export const TableSortDesc = 'DESC';
